import OutrightOutcomeModel from './race-outcome-model';
/**
 * Model for Match Details
 */
export default class HRDetailsModel {
  constructor(data) {
    /**
     * Jockey
     * @type {string}
     */
    this.jockey = data.j;
    /**
     * Jockey file name
     * @type {string}
     */
    this.jockeyFileName = data.jf || '';
    /**
     * Trainer
     * @type {string}
     */
    this.trainer = data.t;
    /**
     * Status id
     * @type {number}
     */
    this.statusId = data.rrsid;
    /**
     * Runner number
     * @type {number}
     */
    this.runnerNumber = data.rn;
    /**
     * Runner position
     * @type {number?}
     */
    this.runnerPosition = data.rp;
    /**
     * Age
     * @type {number}
     */
    this.age = data.age;
    /**
     * Weight
     * @type {number}
     */
    this.weight = data.w;
    /**
     * Weight unit
     * @type {string}
     */
    this.weightUnits = data.wun;
    /**
     * Previous places
     * @type {string}
     */
    this.prevPlaces = data.fjs;
    /**
     * Previus flat places
     * @type {string}
     */
    this.prevFlatPlaces = data.ffs;
    /**
     * Raw outcome string
     * @type {string}
     */
    this.originalDecimalOutcome = data.o;
    /**
     * Horse name
     * @type {string}
     */
    this.name = data.resn || data.n;
    /**
     * Horse bred country
     * @type {string}
     */
    this.bredCountry = data.bc;
    /**
     * Parent time string - taken from parent object
     * @type {string}
     */
    this.time = data.time;
    /**
     * Parent date string - taken from parent object
     * @type {string}
     */
    this.date = data.date;
    /**
     * Parent race name - taken from parent object
     * @type {string}
     */
    this.raceName = data.raceName;
    /**
     * Parent either way label - taken from parent object
     * @type {number}
     */
    this.ewplabel = data.ewplabel;
    /**
     * Parent either way place - taken from parent object
     * @type {number}
     */
    this.eachWayPlace = data.eachWayPlaces;
    /**
     * Parent outcome id - taken from parent object
     * @type {number}
     */
    this.outcomeId = data.outcomeId;
    /**
     * Current odds
     * @type {OutrightOutcomeModel[]}
     */
    this.outcomes = data.odds.map(t => new OutrightOutcomeModel(t));
    /**
     * Previous odds
     * @type {string}
     */
    this.prevOdds = data.prevodds.map(t => new OutrightOutcomeModel(t));
    /**
     * Competitior Id - needed for cast odds
     * @type {number}
     */
    this.competitorId = data.cmid;
    /**
     * External Runner Id - needed for cast odds
     * @type {number}
     */
    this.externalRunnerID = data.extid;
    /**
     * Flag if odd is active
     * @type {boolean}
     */
    this.active = data.rrsa;
  }
}
